import { Component, EventEmitter, Input, Output } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { UI_TOOLS_TRANSLOCO_SCOPE } from '../../ui-tools-transloco-scope';

@Component({
  selector: 'yat-confirm-buttons',
  templateUrl: './confirm-buttons.component.html',
  styleUrls: ['./confirm-buttons.component.scss'],
  providers: [provideTranslocoScope(UI_TOOLS_TRANSLOCO_SCOPE)]
})
export class ConfirmButtonsComponent {
  @Input()
  confirmButtonName: string = '';

  @Output()
  confirmClickMethod: EventEmitter<() => void> = new EventEmitter();

  @Output()
  cancelClickMethod: EventEmitter<void> = new EventEmitter();

  mode: 'confirm' | 'confirmInProgress' = 'confirm';

  confirmButtonClick(): void {
    this.mode = 'confirmInProgress';
    this.confirmClickMethod.emit(() => (this.mode = 'confirm'));
  }

  cancelButtonClick(): void {
    this.mode = 'confirm';
    this.cancelClickMethod.emit();
  }
}
